import React from 'react';
import { ShieldOff, Lock } from 'lucide-react';
import { usePermissions } from '../hooks/usePermissions';
import './AccessDenied.css';

const AccessDenied = ({ viewName }) => {
  const { userRoleDisplay } = usePermissions();

  // Format view name for display
  const formatViewName = (name) => {
    if (!name) return 'this page';
    return name
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="access-denied">
      <div className="access-denied__content">
        <div className="access-denied__icon-wrapper">
          <div className="access-denied__icon-bg">
            <ShieldOff size={48} />
          </div>
          <Lock className="access-denied__lock-icon" size={20} />
        </div>

        <h2 className="access-denied__title">Access Restricted</h2>
        <p className="access-denied__message">
          You don't have permission to access <strong>{formatViewName(viewName)}</strong>.
        </p>

        <div className="access-denied__role-card">
          <div className="access-denied__role-label">Your Current Role</div>
          <div className="access-denied__role-value">{userRoleDisplay}</div>
        </div>

        <p className="access-denied__help">
          Contact your administrator if you need access to this feature.
        </p>

        <button
          className="access-denied__back-btn"
          onClick={() => window.history.back()}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
